<template>
	<QRCode
		:content="content"
	/>
</template>

<script>
import QRCode from '@/components/QRCode';

export default {
	components: {
		QRCode,
	},
	data() {
		return {
			content: this.$root.options.content,
		}
	}
}
</script>

<style>

</style>
